// extracted by mini-css-extract-plugin
module.exports = {"error_margin":"RenewalPeriod_error_margin__1zD-8"};